module.exports = __webpack_public_path__ + "static/media/Apr2-S18.70f02ac4.png";